<template>
    <div class="check"
         @click="isShow">
        <div class="head">
            <i class="back"
               @click="back()"></i>
            <p class="title">作业详情</p>
            <p class="preview"
               @click="preview()">作业预览</p>
        </div>
        <div class="time_box"
             v-if='!is_active'>
            <!-- 2020上半学期期中活动加 -->
            <p class="jzTime">截止时间：{{ endDate | dateFormat('MM月DD日 hh:mm (W)')}}</p>
            <p class="endTime"
               v-if="is_end">已截止</p>
        </div>

        <div class="tab"
             v-if="task_type==1">完成情况</div>
        <div :class="['tabs',{marginTop:is_active}]"
             v-else>
            <!-- 2020上半学期期中活动加 -->
            <div>
                <p @click="cutTab(true)"
                   :class="{'active':tab_active}">完成情况</p>
            </div>
            <div></div>
            <div>
                <p @click="cutTab(false)"
                   :class="{'active':!tab_active}">作业报告</p>
            </div>
        </div>

        <template v-if="loading">
            <!-- <analyze ref="analyze" :finish_num="finish" :average="average" :anums="anums" :bnums="bnums" :cnums="cnums"
                :dnums="dnums" v-if="tab_active&&test_type==4"></analyze> -->
            <results :isActive='is_active'
                     :type="task_type"
                     :message_id='message_id'
                     :classId='classId'
                     :unfinish="unfinish"
                     :finish="finish"
                     :city="1"
                     :stu_info="stu_info"
                     :wrong_num='wrong_num'
                     @child="toNom"
                     v-if="tab_active">
            </results>
            <reports :reportList="reportList"
                     :knows='knows'
                     @child="toAskCheck"
                     v-if="!tab_active">
            </reports>
        </template>
        <loadings v-else></loadings>
        <div :class=" [(is_end&finish>0) || (is_active&finish>0)?'bottom_btn1':'bottom_btn2','bottom_btn']"
             v-if="stu_info.length>0">
            <div class='bottom_btn-box'>
                <div class="bottom_btn-div reward"
                     @click="reward"
                     v-if="(is_end&finish>0) || (is_active&finish>0)">
                    <p><img src="./img/test_jp.png">奖励和评语</p>
                </div>
                <div class="bottom_btn-div share"
                     @click="reportClick">
                    <p><img src="./img/test_fx.png">分享报告给家长</p>
                </div>
            </div>
        </div>
        <!-- <div class="bottom_btn" v-if="(is_end&finish>0) || (is_active&finish>0)">
      <div class="reward" @click="reward">
        <p><img src="./img/test_jp.png">奖励和评语</p>
      </div>
    </div> -->
    </div>
</template>

<script type="text/ecmascript-6">
import headers from 'COMPONENTS/base/header.vue'
import loadings from 'COMPONENTS/base/tealoading.vue'
// import analyze from 'SRC/components/activity/schoolopens/tea/analyze.vue';
import results from 'VIEWS/english/inspect/result.vue'
import reports from 'VIEWS/english/inspect/report.vue'

export default {
    data () {
        return {
            sid: this.$route.params.sid, //21小学22初中
            message_id: this.$route.params.taskid, //作业id
            classId: this.$route.params.classid, //班级id
            task_type: this.$route.params.type, //作业类型
            test_type: this.$route.query.test_type, //作业类型   4开学大检查
            task_name: this.$route.query.task_name,
            begin_date: this.$route.query.begin_date,
            is_end: false, //是否已到截止时间
            endDate: null, //结束时间
            stu_info: [], //学生完成情况
            reportList: [], //错误率数据
            knows: [], //作业报告中的知识点掌握情况
            finish: null, //完成学生
            unfinish: null, //未完成
            tab_active: true, //tab状态
            loading: false,
            is_active: Number(this.$route.query.is_active) || 0, //期末活动
            wrong_num: 0,
            average: null,
            anums: null,
            bnums: null,
            cnums: null,
            dnums: null,
        }
    },
    created () {
        this.getDate();
    },
    destroyed () { },
    components: {
        headers,
        loadings,
        results,
        reports,
        // analyze
    },
    methods: {
        isShow () {
            // if(this.$refs.analyze){this.$refs.analyze.isShow = false};
        },
        back () {
            this.$router.go(-1);
        },
        reportClick () {
            this.$router.push("/base/shareToParent/" + this.classId + "/" + this.message_id + "/" + this.task_type +
                "/" + this.test_type + "/" + this.sid + "?is_active=" + this.is_active);
        },
        preview () {
            //作业预览
            if (this.task_type == 1) {
                this.$router.push('/english/read_preview/' + this.sid + '/' + this.message_id + '/' + this.task_type);
            } else {
                this.$router.push('/english/preview/' + this.sid + '/' + this.message_id + '/' + this.task_type);
            }
        },
        cutTab (flag) {
            this.tab_active = flag;
            this.loading = false;
            if (flag) {
                this.getDate();
            } else {
                this.$http.post(API_URL_TASK_API + '/english/check/report', {
                    sid: this.sid,
                    message_id: this.message_id,
                    unit_class_id: this.classId
                }).then(res => {
                    res = res.data;
                    if (res.response === 'ok') {
                        this.reportList = res.data;
                        this.knows = [];
                        this.loading = true;
                    }
                })

            }
        },
        toNom (stu) {
            if (this.task_type == 1) {
                //子组件触发，去个人详情
                this.$router.push('/english/nom_check/' + this.sid + '/' + this.message_id + '/' + this.task_type +
                    '/' + stu.user_id + '?name=' + stu.real_name)
            } else {
                this.$router.push('/english/preview/' + this.sid + '/' + this.message_id + '/' + this.task_type +
                    '?user_id=' + stu.user_id + '&name=' + stu.real_name + '&score=' + stu.score);
            }
        },
        toAskCheck (ask) {
            let title = '';
            if (ask.ask_no) {
                title = ask.q_no + '(' + ask.ask_no + ')';
            } else {
                title = ask.q_no;
            }
            this.$router.push('/english/single_preview/' + this.sid + '/' + this.message_id + '/' + ask.qid +
                '?title=' + title + '&classId=' + this.classId);
        },
        getDate () {
            let url = '/english/check/task';
            if (this.test_type == 4) {
                url = '/english/check/task/kxdjc';
            }
            this.$http.post(API_URL_TASK_API + url, {
                "message_id": this.message_id,
                'task_type': this.task_type,
                "sid": this.sid,
                "unit_class_id": this.classId
            }).then(res => {
                res = res.data;
                if (res.response === 'ok') {
                    this.finish = res.data.done_student;
                    this.endDate = res.data.end_date;
                    this.is_end = res.data.is_end;
                    this.unfinish = res.data.undone_student;
                    // this.unfinish = res.data.all_student - res.data.done_student;
                    this.stu_info = res.data.stu_info;
                    this.wrong_num = res.data.wrong_num || 0;
                    this.average = res.data.average;
                    this.anums = res.data.anums;
                    this.bnums = res.data.bnums;
                    this.cnums = res.data.cnums;
                    this.dnums = res.data.dnums;
                    this.loading = true;
                }
            })
        },
        reward () {
            this.$router.push("/tea/testreward/" + this.sid + "/" + this.message_id + "/" + this.classId);
        }
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

.check {
    width: 100vw;
    min-height: 100vh;
    background: #f5f9ff;
    overflow-x: hidden;
    position: relative;

    .head {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 10;
        width: 100vw;
        height: 96px / $ppr;
        background: #5e89ef;

        .back {
            position: absolute;
            top: 30px / $ppr;
            left: 24px / $ppr;
            width: 18px / $ppr;
            height: 34px / $ppr;
            background: url(./img/choose_back.png) no-repeat;
            background-size: 100% 100%;
        }

        .title {
            width: 100%;
            height: 96px / $ppr;
            line-height: 96px / $ppr;
            font-size: 34px / $ppr;
            color: #fff;
            text-align: center;
        }

        .preview {
            position: absolute;
            top: 30px / $ppr;
            right: 24px / $ppr;
            z-index: 10;
            font-size: 30px / $ppr;
            color: #fff;
        }
    }

    .time_box {
        padding: 96px / $ppr 24px / $ppr 0;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        background: #5e89ef;

        .jzTime {
            float: left;
            color: #fff;
            font-size: 30px / $ppr;
        }

        .endTime {
            float: right;
            font-size: 30px / $ppr;
            color: #dde7fd;
        }
    }

    .tab {
        position: relative;
        z-index: 2;
        padding: 0 24px / $ppr;
        margin-bottom: 24px / $ppr;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        font-size: 30px / $ppr;
        color: #333;
        background-color: #fff;
    }

    .tabs {
        position: relative;
        z-index: 2;
        width: 100%;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        margin-bottom: 24px / $ppr;
        background-color: #fff;

        &.marginTop {
            margin-top: 2.4rem;
        }

        div {
            float: left;

            p {
                font-weight: 700;
                margin: 0 auto;
                width: 144px / $ppr;
                height: 92px / $ppr;
                text-align: center;
                font-size: 30px / $ppr;
                color: #333;

                &.active {
                    color: #5e89ef;
                    border-bottom: 4px / $ppr solid #5e89ef;
                    border-radius: 4px / $ppr;
                }
            }
        }

        div:nth-child(1) {
            width: 360px / $ppr;
            height: 96px / $ppr;
        }

        div:nth-child(2) {
            width: 1px;
            height: 64px / $ppr;
            background: #dcdcdc;
            margin-top: 19px / $ppr;
        }

        div:nth-child(3) {
            margin-left: -1px;
            width: 360px / $ppr;
            height: 96px / $ppr;
        }
    }
}

.noresources {
    width: 100%;
    height: 300px / $ppr;

    p {
        line-height: 300px / $ppr;
        text-align: center;
    }
}

.tig-bu {
    position: absolute;
    width: 40px / $ppr;
    height: 28px / $ppr;
    font-size: 24px / $ppr;
    background-color: #66cc22;
    color: #fff;
    //background: url('./img/icon_bu.png') no-repeat;
    background-size: 100%;
    margin-left: 12px / $ppr;
    line-height: normal;
    text-align: center;
    top: 34px / $ppr;
    border-radius: 2px;
}

.bottom_btn1 {
    .bottom_btn-div {
        width: 50%;
    }
}

.bottom_btn2 {
    .bottom_btn-div {
        width: 100%;
    }
}

.bottom_btn {
    width: 100%;
    height: 98px / $ppr;
    margin-top: 25px / $ppr;

    .bottom_btn-box {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: space-between;
    }

    .share {
        background: #5e89ef;
    }

    .reward {
        background: #ff6600;
    }

    .reward,
    .share {
        color: #fff;

        p {
            text-align: center;
            margin: 0 auto;
            line-height: 98px / $ppr;
            position: relative;
        }

        img {
            display: inline-block;
            position: relative;
            width: 40px / $ppr;
            top: 8px / $ppr;
            margin-right: 10px / $ppr;
        }
    }
}
</style>
